<template>
    <router-view></router-view>
</template>

<script>
  export default {
    name: 'TimeLineView',
    data() {
      return {
      };
    },
    created() {
    }
  }
</script>

<style>

</style>